export default {
    langzh: "-",
    langen: "Língua Inglesa",
    i18n: "Português",
    today: "Hoje",
    yesterday: "Óntem",
    tomorrow: "Amanhã",
    last7Days: "Últimos sete dias",
    nearly1month: "Quase um mês",
    nearly3months: "Quase três meses",
    next7Days: "Próximos 7 dias",
    nextMonth: "Próximo mês",
    next3Months: "Próximo mês",
    year: "Ano",
    month: "Mês",
    day: "Dia"
}